<template>
  <div id="app">
    <header>
      <h1>Experiment Handler</h1>
      <p class="subtitle">User Registration Portal</p>
    </header>
    <nav>
      <ul class="nav-links">
        <li><router-link to="/register" class="nav-item">Register</router-link></li>
        <li><router-link to="/users" class="nav-item">User List</router-link></li>
        <li><router-link to="/media-upload" class="nav-item">Media Upload</router-link></li>

        <!-- Future Features -->
        <!-- <li><router-link to="/setup">Experiment Setup</router-link></li>
        <li><router-link to="/results">Results Dashboard</router-link></li> -->
      </ul>
    </nav>
    <main>
      <router-view />
    </main>
    <!-- Footer: Uncomment if needed -->
    <!-- <footer>
      <p>&copy; 2024 Experiment Handler. All Rights Reserved.</p>
    </footer> -->
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
/* Reset */
body, html, #app {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Arial, sans-serif;
  color: #333;
  background-color: #f9f9f9;
}

/* Header Styles */
header {
  background: linear-gradient(90deg, #007bff, #0056b3);
  color: white;
  padding: 1.5em 0;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

header h1 {
  margin: 0;
  font-size: 2.4em;
}

header .subtitle {
  font-size: 1.2em;
  margin-top: 0.5em;
  opacity: 0.9;
}

/* Navigation Styles */
nav {
  margin-top: 1em;
}

.nav-links {
  list-style: none;
  padding: 0;
  display: flex;
  justify-content: center;
  gap: 1.5em;
  margin: 0;
}

.nav-links li {
  display: inline;
}

.nav-links a {
  color: rgb(7, 7, 7);
  text-decoration: none;
  font-weight: bold;
  font-size: 1.1em;
}

.nav-links a:hover {
  text-decoration: underline;
}

.router-link-active {
  text-decoration: underline;
}

/* Main Container */
main {
  padding: 2em;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 1.5em;
  background: rgb(255, 255, 255);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
  header h1 {
    font-size: 2em;
  }

  header .subtitle {
    font-size: 1em;
  }

  .container {
    padding: 1em;
  }

  .nav-links {
    flex-direction: column;
    gap: 0.8em;
  }

  .nav-links a {
    font-size: 1em;
  }
}
</style>
